import MenuNav from "../MenuNav";
import estilos from "./Header.module.css";

function Header() {
    return (
        <header className={estilos.header}>
                <img src="./imagens/logo.png" alt="Imagem da logo"/>

                <MenuNav></MenuNav>
        </header>
    )
}

export default Header;